import React from 'react'

import Button from 'common/components/general/Button'

import Avatar from '../../../dataDisplay/Avatar'

import './taxAdvantageExpenseStyles.less'

type TaxAdvantageProps = {
  isAvatarOnly?: boolean
  isButtonDisabled?: boolean
  hasSimpleText?: boolean
  onClick?: () => void
}

const TaxAdvantage = ({
  isAvatarOnly = false,
  hasSimpleText = false,
  isButtonDisabled = false,
  onClick,
}: TaxAdvantageProps) => {
  const avatarDisplayComponent = () => {
    if (isButtonDisabled)
      return (
        <div className="flex flex__center">
          <Avatar className="expense-tax-advantage-avatar-empty" text="T" />
        </div>
      )
    return (
      <Button onClick={onClick} type="text" shape="circle" className="flex flex__center">
        <Avatar className="expense-tax-advantage-avatar-empty expense-tax-advantage-avatar-empty-button" text="T" />
      </Button>
    )
  }

  return isAvatarOnly ? (
    avatarDisplayComponent()
  ) : (
    <div className="container-tax-advantage">
      <Avatar
        className={hasSimpleText ? 'expense-tax-advantage-avatar-empty' : 'expense-tax-advantage-avatar'}
        text="T"
      />
      {hasSimpleText ? (
        <div className="expense-tax-advantage-text">Tax-advantaged</div>
      ) : (
        <div className="expense-tax-advantage-text">
          <div>
            This expense will be <span className="color-blue-6 semi-bold">tax-advantaged</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default TaxAdvantage
